import { SurveyName } from '~/lib/constants/survey/SurveyName';

export const SurveysWithScore: string[] = [
  SurveyName.AIMS,
  SurveyName.AUDIT,
  SurveyName.CET,
  SurveyName.DUDIT,
  SurveyName.EDE_Q,
  SurveyName.FNS,
  SurveyName.GAD7,
  SurveyName.NIAS,
  SurveyName.PHQ8,
  SurveyName.PHQ9,
];
